<template lang="pug">
  div.footer
    // раскомментировать ОТ //footer //
    //footer
      div.footer-wrapper
        //div.left-navigation
          button.btn.btn-icon.download Скачать
        div.right-navigation
          div.page-nav
            label Показывать по:
            select
              option 10
              option 20
          div.pagination
            span.naviate.naviate--prev
            input(value='1')
            span из
            span 120
            span.naviate.naviate--next
    // раскомментировать  ДО сюда //

      //div.footer-wrapper.footer-wrapper--top-border
        div.left-navigation
          button.btn.btn-icon.delete Удалить
        div.right-navigation
          button.btn.cancel Отмена
          button.btn.save Сохранить
</template>

<script>
  export default {
    name: 'components-footer'
  }
</script>
